<div class="bg-blue-2 d-flex al-center sp-between p-4">
  <div>
    <div>
      <span class="text-white fw-extrabold fs-4">Curso 1</span>
    </div>
    <div>
      <span class="text-white fs-6 fw-regular">Ingresa el título y descripción del curso.</span>
    </div>
  </div>
  <div>
    <img src="assets/svg/Icon_close.svg" mat-dialog-close alt="">
  </div>
</div>
<form [formGroup]="courseForm">
  <mat-dialog-content class="p-4 d-flex flex-column content-form">
    <div>
      <div>
        <div class="mb-2">
          <span class="fw-semibold">Título</span>
        </div>
        <input type="text" formControlName="title" placeholder="Ingrese título del curso" class="w-100 border rounded px-3">
      </div>
      <br>
      <div>
        <div class="mb-2">
          <span class=" fw-semibold">Descripción</span>
        </div>
        <textarea type="text" formControlName="description" rows="3" placeholder="Ingrese descripción del curso" class="w-100 border rounded p-3"></textarea>
      </div>
      <br>
      <div>
        <div>
          <span class="fs-6 fw-semibold text-black">Plan</span>
        </div>
        <nz-select class="w-100" formControlName="plans" nzPlaceHolder="Escoja el tipo de plan">
          <nz-option [nzValue]="item.id" [nzLabel]="item.titulo" *ngFor="let item of plans"></nz-option>
        </nz-select>
      </div>
      
    </div>
  </mat-dialog-content>
  <div class="p-4 text-end content-action">
    <mat-dialog-actions align="end">
      <button mat-flat-button class="bg-blue-2 w-100" (click)="saveDataCourse()">
        <span class="fw-bold fs-5 text-white me-3">Guardar cambios</span>
        <img src="assets/svg/Icon_arrow_right_white.svg" alt="">
      </button>
    </mat-dialog-actions>
  </div>
</form>
<ng-container *ngIf="loader">
  <app-loader></app-loader>
</ng-container>